module.exports = __webpack_public_path__ + "img/circle-half.e1be5a5a.svg";